import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ArticleService } from '../../services/article.service';

@Component({
  selector: 'app-article-filter-box',
  templateUrl: './article-filter-box.component.html',
  styleUrls: ['./article-filter-box.component.css']
})
export class ArticleFilterBoxComponent implements OnInit {

  @Input() queryTag: any[];
  @Output() updatedQp = new EventEmitter();

  tags: any[] = [];
  _tags: any[] = [];
  selectedTag: string[] = [];
  params = new HttpParams();
  title = '';
  urlParams: any;
  isLoadTag = true;

  constructor(
    private articleService: ArticleService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    if(this.queryTag !== undefined || this.queryTag !== null){
      this.selectedTag = this.queryTag;
    }
    this.getArticleTags();
  }

  getArticleTags(){
    this.isLoadTag = true;
    this.articleService.getArticleTag().subscribe(
      data => {
        let regTag = [];
        for (let x = 0; x < data.data.length; x++) {
          regTag.push(data.data[x].tag)
        }
        this.tags = regTag.sort();
        this._tags = regTag.sort();
        this.isLoadTag = false;
      },
      error => {
        console.log(error);
      }
    )
  }

  searchTag(){
    let origin = this._tags;

    if(!this.title){
      this.tags = this._tags;
    } else {
      this.tags = origin.filter(res => {
        return res.toLocaleLowerCase().match(this.title.toLowerCase());
      })
    }
  }

  clearAll(){
    this.selectedTag = [];
    this.qpEmitter();
  }

  selectAll(){
    this.selectedTag = this._tags;
    this.qpEmitter();
  }


  onSelect(t){

    if(this.selectedTag.indexOf(t) === -1){
      this.selectedTag.push(t)
      this.qpEmitter();
    } else {
      let ind = this.selectedTag.indexOf(t);
      this.selectedTag.splice(ind, 1);
      this.qpEmitter();
    }
  }

  qpEmitter(){
    this.updatedQp.emit(this.selectedTag);
  }

  checkExistence(i: string){
    if(this.queryTag !== undefined){
      if(this.selectedTag.indexOf(i) === -1){
        return false;
      } else {
        return true;
      }
    }
  }

}
